export default __webpack_public_path__ + "static/media/spiritualLife.48182199.jpeg";